import { Link, useLocation } from 'react-router-dom';

export default function Header() {
  const location = useLocation();
  const linkClass = "text-sm font-medium text-slate-600 hover:text-blue-600 transition-colors";
  return (
    <header
      data-testid="site-header"
      className="sticky top-0 z-40 bg-white/85 backdrop-blur border-b border-slate-100"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="header-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src="/logo.png"
            alt="Go Convert Documents"
            className="h-9 w-9 object-contain rounded-lg"
          />
          <div className="leading-tight">
            <p className="font-display font-extrabold text-lg tracking-tight" style={{ color: 'var(--ink)' }}>
              Go Convert
            </p>
            <p className="text-[10px] uppercase tracking-[0.2em] text-slate-400 -mt-0.5 font-semibold">
              Documents
            </p>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <a data-testid="nav-tools" href="/#all-tools" className={linkClass}>All Tools</a>
          <Link data-testid="nav-blog" to="/blog" className={linkClass}>Blog</Link>
          <a data-testid="nav-how" href="/#how-it-works" className={linkClass}>How it works</a>
          <Link data-testid="nav-partners" to="/partners" className={linkClass}>Partners</Link>
        </nav>

        <div className="flex items-center gap-2">
          {location.pathname === '/' ? (
            <a href="#all-tools" data-testid="header-cta" className="btn-primary" style={{ padding: '10px 22px', fontSize: 14 }}>
              Get started
            </a>
          ) : (
            <Link to="/" data-testid="header-home-cta" className="btn-secondary" style={{ padding: '10px 22px', fontSize: 14 }}>
              ← Home
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
